import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { middleburyConfig } from "./data";

export default function MiddleburyPage() {
  return <CityPageTemplate config={middleburyConfig} />;
}